import { Button, ModalV2 } from '@components'
import { PermissionSet, useBusinessContext, usePermission } from '@context'
import { exportProductsCsv } from '@query'
import React, { useState } from 'react'
import toast from 'react-hot-toast'
import { useTranslation } from 'react-i18next'
import { FaDownload, FaPlus } from 'react-icons/fa'
import { FaFileCsv } from 'react-icons/fa6'
import { ProductFormModal } from './ProductFormModal'
import { ActionBar } from '@root/components/ActionBar/ActionBar'
import { ProductImportWizard } from '@containers/CSVImportWizard/ProductImportWizard'

interface Props {
  onSearch: (value: string) => void
  searchTerm: string
}

export const ProductActionBar: React.FC<Props> = ({ onSearch, searchTerm }) => {
  const [t] = useTranslation()
  const [showCreate, setShowCreate] = useState(false)
  const [showImport, setShowImport] = useState(false)
  const { slug } = useBusinessContext()
  const hasEditPermission = usePermission(PermissionSet.INVOICING_EDIT)

  const onExportClick = () =>
    toast.promise(exportProductsCsv({ slug }, { search: searchTerm || undefined }), {
      loading: t('general.loading'),
      success: t('general.success'),
      error: t('general.error')
    })

  const primaryButtons = [
    <Button key="create-button" icon={<FaPlus />} onClick={() => setShowCreate(true)}>
      {t('products.actionBar.addNew')}
    </Button>,
    <Button key="csv-import-products" icon={<FaFileCsv />} onClick={() => setShowImport(true)}>
      {t('products.importButton')}
    </Button>,
    <Button key="csv-export-products" icon={<FaDownload />} onClick={onExportClick}>
      {t('products.exportButton')}
    </Button>
  ]

  return (
    <>
      <ActionBar
        searchPlaceholder={t('products.actionBar.search')}
        onSearch={search => onSearch(search)}
        primaryButtons={hasEditPermission && primaryButtons}
      />
      <ProductFormModal isVisible={showCreate} handleOnClose={() => setShowCreate(false)} />

      <ModalV2
        isVisible={showImport}
        header={t('products.importTitle')}
        handleOnClose={() => setShowImport(false)}
        width={800}
        height={900}
      >
        <ProductImportWizard onComplete={() => setShowImport(false)} />
      </ModalV2>
    </>
  )
}
